import { render } from "./flats-crm-items-list.vue?vue&type=template&id=455dce89"
import script from "./flats-crm-items-list.vue?vue&type=script&lang=js"
export * from "./flats-crm-items-list.vue?vue&type=script&lang=js"

import "./flats-crm-items-list.vue?vue&type=style&index=0&id=455dce89&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__